module.exports = __webpack_public_path__ + "static/media/person.4afb97b3.png";